import { useState } from 'react';

import {
  AlertTypography,
  ButtonBox,
  DialogButton,
  DialogContainer,
  FilledButton,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from './styles';

interface ConfirmEditDialogProps {
  title: string;
  text: string;
  modalCallback: () => void;
}

export default function ConfirmEditDialog({
  title,
  text,
  modalCallback,
}: ConfirmEditDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const handleConfirm = (): void => {
    modalCallback();
    handleClose();
  };

  return (
    <>
      <DialogButton onClick={handleOpen}>{title}</DialogButton>
      <StyledDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="confirmation dialog"
      >
        <DialogContainer>
          <TextTypography>Você gostaria de {text}?</TextTypography>
          <ButtonBox>
            <OutlinedButton onClick={handleClose}>Não</OutlinedButton>
            <FilledButton onClick={handleConfirm}>Sim</FilledButton>
          </ButtonBox>
          <AlertTypography>
            Atenção! Esta ação não poderá ser desfeita.
          </AlertTypography>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
